import {
  deleteValues,
  payloadBool,
  payloadFormatArray,
} from "helpers/utils/utilities";

// GENERATES PAYLOAD FOR DIFFERENT STEPS OF PROJECT FORM SUBMISSION
export const generatePayload = (step, data, editMode, pitch = {}) => {
  let payload;
  switch (step) {
    case 0:
      // STEP 0: PROJECT OVERVIEW PAYLOAD
      payload = {
        ...data,
        is_download_enabled: payloadBool(data?.is_download_enabled),
        is_view_enabled: payloadBool(data?.is_view_enabled),
        challenge_id: data?.challenge_id?.key,
        lab_id: data?.active_labs?.key,
        media_type: data.iframe_code
          ? "embedded"
          : data?.cover_media
          ? "image"
          : "none",
        cover_media: data.iframe_code
          ? data?.iframe_code
          : data?.cover_media ?? "",
      };

      // REMOVE TEMP FIELDS BEFORE SUBMIT
      deleteValues(payload, ["active_labs", "iframe_code"]);

      // REMOVE INVALID EMBED CODES OR EMPTY MEDIA ON EDIT
      if (!editMode && !payload.cover_media)
        deleteValues(payload, ["cover_media"]);

      // REMOVE lab_id IF NOT SELECTED
      if (!payload.lab_id) deleteValues(payload, ["lab_id"]);
      break;

    case 1:
      // STEP 1: PITCH + TASK PAYLOAD
      payload = {
        template_id: pitch?.id,
        pitch_id: payloadFormatArray(pitch?.challenge_pitch, "id"),
        pitch_answer: payloadFormatArray(pitch?.challenge_pitch, "answer")?.map(
          (d) => (d ? d?.toString("html") : "") // CONVERT RICH TEXT TO HTML STRING
        ),
        task_id: payloadFormatArray(pitch?.challenge_task, "id"),
        task_answer: payloadFormatArray(pitch?.challenge_task, "answer").map(
          (d) => (d === "yes" || d === "no" ? d : payloadBool(d)) // CONVERT BOOLEAN STRINGS
        ),
      };
      break;
  }
  return payload;
};

// RETURNS REQUIREMENT TYPES BASED ON ACTIVE TAB
export const getRequirementTypesWithTab = (tab) => {
  switch (tab) {
    case 1:
      return ["pitch", "task"];
    case 2:
      return ["gallery", "file"];
    default:
      return [];
  }
};

// CHECKS IF ALL GIVEN REQUIREMENT TYPES ARE MARKED AS COMPLETED
export const isRequirementCompleted = (requirements, types) => {
  const filteredRequirements = requirements.filter((req) =>
    types.includes(req.type)
  );
  return (
    filteredRequirements?.length &&
    filteredRequirements.every((req) => req.status === "completed")
  );
};
